export default function ArrowRightIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5859 11L9 14.5859L9 16L10.4141 16L16.4141 10L10.4141 4L9 4L9 5.41406L12.5859 9L4 9L4 11L12.5859 11Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
